import Reflux from 'reflux';
import { ClipboardActions } from 'actions';

const ClipboardStore = Reflux.createStore({
  listenables: [ClipboardActions],
  data: {
    object: null
  },

  getInitialState() {
    return this.data;
  },

  init() {
    const clipboard = JSON.parse(localStorage.getItem('clipboard'));
    if (window) {
      window.addEventListener('storage', () => {
        const clipboard = JSON.parse(localStorage.getItem('clipboard'));
        this.data = {
          ...this.data,
          ...clipboard
        };
        this.trigger(this.data);
      });
    }
    this.data = {
      ...this.data,
      ...clipboard
    };
  },

  copy(object) {
    this.data.object = object;
    this.trigger(this.data);
    this.serialize();
  },

  paste() {
    return this.data.object;
  },

  serialize() {
    localStorage.setItem('clipboard', JSON.stringify(this.data));
  }
});

export default ClipboardStore;



// WEBPACK FOOTER //
// ./src/js/stores/Clipboard.js